export enum ButtonEnum {
	BUTTON_CANCEL = "Cancel",
	BUTTON_CANCEL_ALL = "CancelAll",
	BUTTON_CLOSE = "Close",
	BUTTON_CONTINUE = "BUTTON_CONT",
	BUTTON_FINISH = "Finish",
	BUTTON_FINISH_GO = "Finish_Go",
	BUTTON_OK = "OK",
	BUTTON_NEXT_PAGE = "NextPage",
	BUTTON_PREV_PAGE = "PrevPage",
	BUTTON_RUN = "BUTTON_RUN",
	BUTTON_RETRY = "Retry",
	BUTTON_SAVE = "Save",
	BUTTON_SAVE_COPY = "Save_Copy",
	BUTTON_SAVE_GO = "Save_Go",
	BUTTON_SAVE_NEW = "Save_New",
	BUTTON_SKIP = "BUTTON_SKIP",
	BUTTON_UPDATE = "BUTTON_UPDATE",
}